import { scrollToDisclosure } from '../../utils/scrollToDisclosure';

export const createSuperScriptLinkHtml = (disclosureNumber: number): string => {
    setTimeout(() => {
        const linkElements = document.querySelectorAll('[class^=disclosure-super-script-link]');
        if (linkElements && linkElements.length > 0) {
            for (const linkElement of linkElements) {
                linkElement.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    scrollToDisclosure('disclosure-1', 180);
                });
            }
        }
    }, 100);

    return `<a class='disclosure-super-script-link-${disclosureNumber}' href='#' style='cursor: pointer; color: blue;'>${disclosureNumber}</a>`;
};

export { scrollToDisclosure };
